import {
  ApplicationConfig,
  inject,
  provideBrowserGlobalErrorListeners,
  provideEnvironmentInitializer,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
} from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AuthInterceptor } from '@core/services/interceptors/auth.interceptor';
import { FleetAssignmentInterceptor } from '@core/services/interceptors/fleet-assignment.interceptor';
import { HttpErrorsInterceptor } from '@core/services/interceptors/http.interceptor';
import { WithCredentialsInterceptor } from '@core/services/interceptors/with-credentials.interceptor';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
import { RECAPTCHA_SETTINGS, RECAPTCHA_V3_SITE_KEY, RecaptchaSettings } from 'ng-recaptcha-2';
import { RecaptchaConfigService } from '@core/services/recaptcha-config.service';
import { RouterNavigationFeedbackService } from '@core/services/router-navigation-feedback.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    ),
    // Muestra el loader global durante la navegacion y reporta las navegaciones que
    // fallan (p. ej. un chunk lazy que no descarga), que de otro modo abortan en
    // silencio y hacen parecer que "el menu no hace nada".
    provideEnvironmentInitializer(() => void inject(RouterNavigationFeedbackService)),
    provideHttpClient(
      withInterceptors([
        WithCredentialsInterceptor,
        AuthInterceptor,
        // FleetAssignmentInterceptor,
        HttpErrorsInterceptor,
      ]),
    ),
    {
      provide: MAT_ICON_DEFAULT_OPTIONS,
      useValue: { fontSet: 'material-symbols-outlined' },
    },
    // reCAPTCHA: RECAPTCHA_V3_SITE_KEY debe proveerse en la raíz porque
    // ReCaptchaV3Service es `providedIn: 'root'` (singleton) — un provider
    // a nivel de componente queda invisible para su constructor.
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useFactory: (config: RecaptchaConfigService) => config.recaptchaSiteKeyV3,
      deps: [RecaptchaConfigService],
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useFactory: (config: RecaptchaConfigService): RecaptchaSettings => ({
        siteKey: config.recaptchaSiteKeyV2,
      }),
      deps: [RecaptchaConfigService],
    },
  ],
};
